export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-rate/index.js